import React, { useState } from 'react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-opacity-70 backdrop-filter backdrop-blur-lg">
      <nav className="container mx-auto px-6 py-3">
        <div className="flex justify-between items-center">
      	      <a href="#top" className="text-2xl font-bold text-blue-300">Suprith S</a>
          <div className="hidden md:flex space-x-4">
            {['About', 'Education', 'Experience', 'Skills', 'Projects', 'Achievements', 'Contact'].map((item) => (
              <a key={item} href={`#${item.toLowerCase()}`} className="hover:text-blue-300 transition duration-300">{item}</a>
            ))}
          </div>
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden focus:outline-none">
            <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
              {isOpen ? (
                <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
              ) : (
                <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
              )}
            </svg>
          </button>
        </div>
        {isOpen && (
          <div className="md:hidden mt-4">
            {['About', 'Education', 'Experience', 'Skills', 'Projects', 'Achievements', 'Contact'].map((item) => (
              <a key={item} href={`#${item.toLowerCase()}`} className="block py-2 hover:text-blue-300 transition duration-300">{item}</a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;